module.exports = __webpack_public_path__ + "h5/img/before-service.77d19ff6.jpg";